module.exports = __webpack_public_path__ + "static/media/top-nfts-10.b3086832.jpg";